module.exports = __webpack_public_path__ + "static/media/lumin-bottles-with-two-sample-swatches.464c9e33.jpg";